module.exports = __webpack_public_path__ + "img/SMT_01_Mr_Tan_Kwang_Cheak.9d2d3462.jpg";